import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_ADD_APPOINTMENT')